import { Text } from "@medusajs/ui";
import { VariantPrice } from "types/global";

export default function PreviewPrice({ price }: { price: VariantPrice }) {
  if (!price) {
    return null;
  }

  return (
    <>
      <Text className="text-primary-600 text-lg font-bold" data-testid="price">
        {price.calculated_price}
      </Text>
      {price.price_type === "sale" && (
        <Text className="line-through text-gray-500 text-xs font-light" data-testid="original-price">
          {price.original_price}
        </Text>
      )}
    </>
  );
}
